<template>
  <v-card outlined id="map" height="100%" width="100%"></v-card>
</template>

<script>
import MapService from "../../services/MapService";
import MapServicePopUp from "../../services/MapServicePopUp";
import { mapState } from "vuex";

export default {
  name: "TheMap",
  // DATA
  props: {
    posts: Array,
    shortName: {
      type: String,
      required: true,
      default: ""
    },
    placeType: String,
    longitude: Number,
    latitude: Number,
    bbox: Array,
    destinations: Array,
    searchIfMapMove: Boolean,
    radius: Number,
    clickOnButtonToDisplayTheMap: {
      type: Boolean,
      default: () => false
    },
    screenSizeAllowTheMapToBeDisplay: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      map: null,
      isTouchScreenAvailable: false,
      mapBoxStyleHasBeenCharged: false
    };
  },
  methods: {
    highlightLocation(location) {
      MapService.highlightPost(this.map, location);
    },
    unHighlightLocation(location) {
      MapService.unHighlightPost(this.map, location);
    }
  },
  computed: {
    ...mapState({
      closeHoverPopup: state => state.search.closeHoverPopup,
      isHoverPopupDisplayed: state => state.search.isHoverPopupDisplayed,
      hoverActiveDestination: state => state.search.hoverActiveDestination
    }),
    destinationDisplayed() {
      return this.$store.getters["search/destinationDisplayed"];
    },
    destinationIds() {
      return this.destinations
        .map(destination => destination.id)
        .sort()
        .join("");
    }
  },
  // LIFE CYCLE HOOKS
  created() {
    this.isTouchScreenAvailable = "ontouchstart" in document.documentElement;
  },
  mounted() {
    this.map = MapService.initMap(this.bbox);
    this.map.on("load", () => {
      this.$emit("mapBoxStyleHasBeenCharged");
      this.mapBoxStyleHasBeenCharged = true;
      MapService.addFixedLayers(this.map);
      MapService.initLocationLayer(
        this.map,
        this.longitude,
        this.latitude,
        this.shortName,
        this.placeType,
        this.radius
      );
      this.$emit("stopLoadingMap", "initMap");
      this.$emit("stopLoadingMap", "map");
    });
    // MAP CONFIGURATION FOR TOUCH SCREEN
    if (this.isTouchScreenAvailable) {
      // add search state in url when layer is touched
      MapServicePopUp.setMobileTouchEvent(this.map);
      // MAP CONFIGURATION FOR DESKTOP SCREEN
    } else {
      MapServicePopUp.setDesktopHoverEvent(this.map);
    }
    this.map.on("displayDestinationPage", event => {
      this.$router.push({
        name: this.$router.currentRoute.name,
        query: {
          ...this.$route.query,
          destinationId: event.destinationId
        }
      });
    });
    this.map.on("moveend", () => {
      /* Emit New bbox coordonates to TheSearch */
      this.$emit("bboxHasBeenUpdated", MapService.getBboxFromMap(this.map));
      this.$emit("mapMovementState", "stop");
    });
  },
  // WATCHERS
  watch: {
    destinationIds() {
      if (this.mapBoxStyleHasBeenCharged) {
        this.isTouchScreenAvailable
          ? MapService.initMobileDestinationsLayer(this.map, this.destinations)
          : MapService.initDesktopDestinationsLayer(
              this.map,
              this.destinations
            );
      }
    },
    bbox() {
      MapService.initLocationLayer(
        this.map,
        this.longitude,
        this.latitude,
        this.shortName,
        this.placeType,
        this.radius
      );
      if (
        (this.placeType != "" && this.shortName != "") ||
        this.placeType === "country" ||
        this.placeType === "myPosition" ||
        this.placeType === "range" ||
        this.placeType === "bbox"
      ) {
        /* map is move by an undirect user action */
        this.$emit("mapMovementState", "moving");
        MapService.fitBounds(this.map, this.bbox);
      }
    },
    closeHoverPopup(value) {
      if (value === false) MapServicePopUp.setCloseHoverPopupToFalse();
      if (value === true) MapServicePopUp.closeHoverPopup();
      this.map.fire("removeHighlightDestination");
    },
    // watcher to display/remove a hover active symbol on a destination
    hoverActiveDestination(destination) {
      if (this.mapBoxStyleHasBeenCharged) {
        if (
          Object.keys(destination).length === 0 &&
          destination.constructor === Object
        )
          return MapService.removeHoverActiveDestinationLayer(this.map);
        return MapService.addHoverActiveDestinationLayer(this.map, destination);
      }
    },
    destinationDisplayed(newDestination, oldDestination) {
      // add and remove layer only if style is charged
      if (this.mapBoxStyleHasBeenCharged) {
        // removeLayer if newDestination is Empty
        if (
          Object.keys(newDestination).length === 0 &&
          newDestination.constructor === Object
        ) {
          MapService.removeActiveDestinationLayer(this.map);
        } else {
          // remove oldDestinationLayer if oldDestination was an actual destination
          if (Object.keys(oldDestination).length > 0) {
            MapService.removeActiveDestinationLayer(this.map);
            // add new destination layer
          }
          MapService.addActiveDestinationLayer(this.map, newDestination);
        }
      }
    },
    // WATCHERS TO RESIZE THE MAP
    screenSizeAllowTheMapToBeDisplay(value) {
      if (value) this.map.resize();
    },
    clickOnButtonToDisplayTheMap(value) {
      if (value) this.map.resize();
    }
  }
};
</script>

<style scoped>
#map {
  height: 100%;
  width: 100%;
}
</style>
